import styled from 'styled-components';
import { DatePicker } from 'antd';
import { COLOR, FONT_SIZE, RADIUS } from '../../../constants/theme';

export const Field = styled.div`
  margin: 0;
`;

export const FieldLabel = styled.label`
  display: block;
  margin-bottom: 5px;
  font-size: ${FONT_SIZE.label};
  font-weight: 500;
  color: ${COLOR.text};
`;

export const RequiredMark = styled.span`
  margin-right: 2px;
  color: ${COLOR.error};
`;

export const DateInput = styled(DatePicker)`
  width: 100%;
  height: 40px;
  border-radius: ${RADIUS.md};
  border-color: ${({ $hasError }) => ($hasError ? COLOR.error : COLOR.border)};

  input {
    font-size: ${FONT_SIZE.value};
    color: ${COLOR.text};
  }

  input::placeholder {
    color: ${COLOR.textMuted};
  }

  &.ant-picker-focused {
    border-color: ${COLOR.primary};
    box-shadow: 0 0 0 1.5px ${COLOR.primary};
  }
`;
